"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerDocumentsInfos = void 0;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../hooks/useTranslations_simplified-registration-BrandPartner");
var _interfaces = require("../../interfaces");
var _FetchResult = require("../FetchResult");
var _TranslationKey_simplifiedRegistrationBrandPartner = require("../TranslationKey_simplified-registration-BrandPartner");
var _registrations = require("./registrations");
async function fetchCustomerDocumentInfo(api, customerId, customHeaders) {
  const emptyCustomerDocumentApprovals = [];
  try {
    const [documents, approvals] = await Promise.all([(0, _globalApiClientReact.getCustomerDocumentsInfos)(api, customerId, {}, customHeaders), (0, _globalApiClientReact.getCustomerDocumentApprovals)(api, customerId, {}, customHeaders)]);
    const isSuccess = _FetchResult.FetchResult.isSuccess(documents.status, approvals.status);
    if (isSuccess) {
      const data = documents.data.map(info => {
        const collection = approvals.data.collection.length > 0 ? approvals.data.collection : [];
        const allApprovals = collection;
        const documentApproval = allApprovals.find(approval => approval.documentIds.includes(info.documentId));
        return {
          ...info,
          approval: documentApproval
        };
      });
      return data;
    }
    return undefined;
  } catch (error) {
    return _FetchResult.FetchResult.errorFor(emptyCustomerDocumentApprovals);
  }
}
const useCustomerDocumentsInfos = reFetchkey => {
  const {
    data: registrationData
  } = (0, _registrations.useRegistrationData)();
  const registrationCustomerId = registrationData?.customerId ?? _auth.NOT_LOGGED_IN_USER_ID;
  const headers = (0, _hooks.useCustomHeaders)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const errorMsg = formatMessage(_TranslationKey_simplifiedRegistrationBrandPartner.TranslationKey.cannotGetData);
  return (0, _swr.default)(registrationCustomerId && registrationCustomerId !== -1 ? [registrationCustomerId, reFetchkey, 'documentInfo'] : null, async () => {
    const result = await fetchCustomerDocumentInfo(api, registrationCustomerId, headers);
    if (result) {
      return result;
    }
    throw new Error('request failed fetch document approvals');
  }, {
    revalidateOnFocus: false,
    onError(err) {
      if (err) {
        setNotificationData({
          isOpen: true,
          message: errorMsg,
          type: _interfaces.MessageType.error
        });
      }
    }
  });
};
exports.useCustomerDocumentsInfos = useCustomerDocumentsInfos;